<div id="conteneur" class="w-100">
  @if (customerForm && customerForm.controls) {
    <form [formGroup]="customerForm" class="form-container" (ngSubmit)="submitForm()">
      <div class="questions">
        @for (question of surveyJsonForm.customerSurvey.survey; track question) {
          <div>
            @if (customerForm.controls[question.uniqueId]) {
              @switch (question.type) {
                @case ('toggle') {
                  <app-yes-no-question
                    [form]="customerForm"
                    [question]="question">
                  </app-yes-no-question>
                }
                @case ('2scale') {
                  <app-scale
                    [form]="customerForm"
                    [question]="question">
                  </app-scale>
                }
                @case ('3scale') {
                  <app-scale
                    [form]="customerForm"
                    [question]="question">
                  </app-scale>
                }
                @case ('dropdown') {
                  <div class=" question w-100 d-flex mb-2" >
                    <span class="mb-2 w-50">{{ question.text }}</span>
                    <ng-select  class="dropdown w-50" [formControlName]="question.uniqueId" [items]="dropDownItemsMap[question.uniqueId]" bindLabel="text" bindValue="id"
                      [multiple]="false" [clearable]="false" [searchable]="true">
                    </ng-select>
                  </div>
                }
                @case ('date') {
                  <div class="w-100 d-flex mb-2 question">
                    <span class="mb-2 w-50">{{ question.text }}</span>
                    <input  type="text" [formControlName]="question.uniqueId"
                      class="form-control w-50" [matDatepicker]="customerDatePicker"
                      onkeydown="return false" readonly autocomplete="off"
                      (click)="customerDatePicker.open()" (focus)="customerDatePicker.open()"/>
                      <mat-datepicker #customerDatePicker></mat-datepicker>
                    </div>
                  }
                  @case ('number') {
                    <div class="w-100 d-flex mb-2 question">
                      <span class="mb-2 w-50">{{ question.text }}</span>
                      <input #inputNumber [formControlName]="question.uniqueId" type="number"
                        class="form-control w-50 "/>
                      </div>
                    }
                    @case ('freeText') {
                      <div class="text-center question">
                        <span class="d-block mb-2">{{ question.text }}</span>
                        <textarea [formControlName]="question.uniqueId"
                          [attr.maxlength]="question.max_length"
                          class="text-etape form-control"
                          rows="4">
                        </textarea>
                      </div>
                    }
                  }
                }
              </div>
            }
          </div>
          <div class="mt-3 pt-2 w-100 d-flex justify-content-center">
            <button type="submit" class="btn btn-primary action-button" [disabled]="customerForm.pristine">
              <i class="fas fa-save me-2"></i>{{ 'SURVEY.SUBMIT' | translate }}
            </button>
          </div>
        </form>
      }
    </div>
